export { useSwitch } from "./useSwitch.web";
//# sourceMappingURL=index.web.js.map